let RegistryDataParser = require('./registryDataParser');

const CHAIN_NONE = 0;
const CHAIN_ISEP_DOWNLOAD = 1;
const CHAIN_ISEP_UPLOAD = 2;
const CHAIN_ISRT = 2;

export class Registry {

	defaultOptions() {
		return {
			logResult: {
				filled: "filled",
				discarded: "discarded",
			},
			idCardType: {
				idCard: "id_card",
				passport: "passport",
				permit: "res_permit",
			},
			searchBy: {
				name: 'name',
				op: 'op',
				passport: 'passport',
				rp: 'rp',
			},
			traffic: true,
			countryOfOriginId: null,
			private: {
				loadAuthoritiesTimeout: null,
				sequenceUUID: null,
				isepInputData: null,
				isepWriteResult: null,
			},
		};
	}

	constructor() {
		var options = $('#js-opts-common').data('registry');
		this.$options = $.extend({}, this.defaultOptions(), options || {});

		this.handleButtons();
	}

	//=====================================================================
	// Private methods
	//=====================================================================

	formDataToObject($form) {
		var unindexed_array = $form.serializeArray();
		var indexed_array = {};

		$.map(unindexed_array, function (n, i) {
			indexed_array[n['name']] = n['value'];
		});
		return indexed_array;
	}

	submitForm($form) {
		var app = this,
			data = app.formDataToObject($form);

		app.formDisable($form);
		$customs.cleanErrors();
		$('#result-panel').hide();

		$.ajax({
			type: $form.attr('method'),
			url: $form.attr('action'),
			data: JSON.stringify(data),
			success(r) {
				app.formEnable($form);
				app.processSuccess(r);
			},
			error(r) {
				app.formEnable($form);
				app.processError(r, undefined, null);
			},
			dataType: "json",
			contentType: "application/json",
			timeout: 120000,
		});
	}

	formDisable($form) {
		$form.find("input").attr('disabled', 'disabled');
		$form.find("select").attr('disabled', 'disabled');
		$form.find("button").attr('disabled', 'disabled');

		$('.loading-registry-animation').show();
	}

	registryButtonDisable() {
		$('.js-lookup-registry-crv').addClass('disabled');
		$('.js-lookup-registry-rob').addClass('disabled');
		$('.js-lookup-registry-ros').addClass('disabled');
		$('.js-lookup-registry-isep').addClass('disabled');
		$('.jjs-upload-registry-isep').addClass('disabled');

		$('.loading-registry-animation').show();
	}

	formEnable($form) {
		$form.find("input").removeAttr('disabled');
		$form.find("select").removeAttr('disabled');
		$form.find("button").removeAttr('disabled');

		this.setPositionType($("input.placeTypeRadio:checked").attr('id'));

		$('.loading-registry-animation').hide();
	}

	registryButtonEnable() {
		$('.js-lookup-registry-crv').removeClass('disabled');
		$('.js-lookup-registry-ros').removeClass('disabled');
		$('.js-lookup-registry-rob').removeClass('disabled');
		$('.js-lookup-registry-isep').removeClass('disabled');
		$('.js-upload-registry-isep').removeClass('disabled');

		$('.loading-registry-animation').hide();
	}

	//---------------------------------------------------------------------


	processSuccess(data) {
		var $resultPanel = $('#result-panel'),
			parser = new RegistryDataParser(data),
			html = parser.getHtml();
		if (html) {
			$resultPanel.find('.panel-body').html(html);
			$resultPanel.show();
		}

		if (("isepSelectResponse" in data) && data.isepSelectResponse
			&& ("response" in data.isepSelectResponse) && data.isepSelectResponse.response
			&& ("outputFileLink" in data.isepSelectResponse.response) && data.isepSelectResponse.response.outputFileLink) {
			window.$customs.displayDocumentPopup(data.isepSelectResponse.response.outputFileLink, null);
		}
	}

	//---------------------------------------------------------------------

	/**
	 * @param $select
	 * @param value
	 */
	setSelectValue($select, value) {
		if (value != null) {
			var $option = $("<option value=\"" + value + "\" selected>" + value + "</option>");
			$select.append($option).trigger('change');
		}
	}

	/**
	 *
	 */
	processStagecoachData(data, fillOperator) {
		var app = this,
			filled = [];
		if (('rz' in data) && data.rz) {
			app.setSelectValue($('#licensePlate'), data.rz);
			filled.push('licensePlate');
		}
		if (('vin' in data) && data.vin) {
			$('#vin').val(data.vin).trigger('change');
			filled.push('vin');
		}
		if (('tovarniZnacka' in data) && data.tovarniZnacka) {
			app.setSelectValue($('#horseOrStagecoachType-vehicle'), data.tovarniZnacka);
			filled.push('horseOrStagecoachType-vehicle');
		}
		if (('barva' in data) && data.barva) {
			app.setSelectValue($('#horseBreed'), data.barva);
			filled.push('horseBreed');
		}

		if (fillOperator && ('provozovatel' in data) && data.provozovatel) {
			filled = filled.concat(app.processOperatorData(data.provozovatel));
		}
		return filled;
	}

	/**
	 * @param fullData
	 * @param $desperadoBlock
	 * @param lookupByPassport
	 */
	processDesperadoData(fullData, $desperadoBlock, lookupByPassport) {
		//Wrong data format
		if (!('robResponse' in fullData) || !('response' in fullData.robResponse)) {
			return [];
		}

		if (window.$desperadoController) {
			window.$desperadoController.lockDesperado(true);
		}

		var app = this,
			cardType = app.$options.idCardType,
			filled = [],
			data = null,
			personalData = null,
			input = null;

		if (fullData.robResponse && ('uuid' in fullData.robResponse)) {
			app.$options.private.sequenceUUID = fullData.robResponse.uuid;
			if (app.$options.private.isepInputData) {
				app.$options.private.isepInputData.uuid = app.$options.private.sequenceUUID;
			}
		}

		if (fullData.robResponse && fullData.robResponse.response) {
			personalData = fullData.robResponse.response;
			data = fullData.robResponse;
		} else if (('crrResponse' in fullData) && fullData.crrResponse && fullData.crrResponse.response) {
			personalData = fullData.crrResponse.response;
			data = fullData.crrResponse;
		}

		if (personalData && ('aifo' in personalData)) {
			if (app.$options.private.isepInputData) {
				app.$options.private.isepInputData.aifo = personalData.aifo;
			}
			$desperadoBlock.find('[id^=desperado-aifo-]').val(personalData.aifo).trigger('change');
		}

		if (data && personalData) {
			if (!lookupByPassport) {
				if (('cisloOp' in data) && data.cisloOp) {
					$desperadoBlock.find('[id^=desperado-identification-]').val(cardType.idCard).trigger('change');
					$desperadoBlock.find('[id^=desperado-cardNumber-]').val(data.cisloOp).trigger('change');
					filled.push('desperado-cardNumber');
					input = input ? input : $desperadoBlock.find('[id^=desperado-cardNumber-]');
				} else if (('cisloPasu' in data) && (data.cisloPasu.length > 0)) {
					$desperadoBlock.find('[id^=desperado-identification-]').val(cardType.passport).trigger('change');
					$desperadoBlock.find('[id^=desperado-cardNumber-]').val(data.cisloPasu[0]).trigger('change');
					filled.push('desperado-cardNumber');
					filled.push('desperado-identification');
					input = input ? input : $desperadoBlock.find('[id^=desperado-cardNumber-]');
				}
			}

			if (('jmeno' in personalData) && personalData.jmeno) {
				$desperadoBlock.find('[id^=desperado-firstName-]').val(personalData.jmeno).trigger('change');
				filled.push('desperado-firstName');
				input = input ? input : $desperadoBlock.find('[id^=desperado-firstName-]');
			}
			if (('prijmeni' in personalData) && personalData.prijmeni) {
				$desperadoBlock.find('[id^=desperado-lastName-]').val(personalData.prijmeni).trigger('change');
				filled.push('desperado-lastName');
				input = input ? input : $desperadoBlock.find('[id^=desperado-lastName-]');
			}
			if (('datumNarozeni' in personalData) && personalData.datumNarozeni) {
				var matches = personalData.datumNarozeni.match(/(?<y>\d+)-(?<m>\d+)-(?<d>\d+).*/);
				if (matches && ('groups' in matches) && matches.groups) {
					var date = "";
					if ((('d' in matches.groups) && matches.groups.d)
						&& (('m' in matches.groups) && matches.groups.m)
						&& (('y' in matches.groups) && matches.groups.y)) {
						date += matches.groups.d + "." + matches.groups.m + "." + matches.groups.y;
					}
					$desperadoBlock.find('[id^=desperado-birthDate-]').val(date).trigger('change');
					filled.push('desperado-birthDate');
					input = input ? input : $desperadoBlock.find('[id^=desperado-birthDate-]');
				}
			}

			var personNote = $desperadoBlock.find('[id^=desperado-note-]').val();
			if (('omezeniSvepravnosti' in personalData) && personalData.omezeniSvepravnosti) {
				if (personNote.length > 0) {
					personNote += "; ";
				}
				personNote += "Svéprávnost: " + personalData.omezeniSvepravnosti;
			}
			if (('cisloDatoveSchranky' in personalData) && personalData.cisloDatoveSchranky) {
				if (personNote.length > 0) {
					personNote += "; ";
				}
				personNote += "Číslo datové schránky: " + personalData.cisloDatoveSchranky;
			}
			if (personNote.length > 0) {
				$desperadoBlock.find('[id^=desperado-note-]').val(personNote).trigger('change');
				filled.push('desperado-note');
			}
			if (('trvalyPobyt' in personalData) && personalData.trvalyPobyt) {
				filled = filled.concat(app.processDesperadoAddress(personalData.trvalyPobyt, $desperadoBlock));
			}
		}

		if (('crrResponse' in fullData)
			&& fullData.crrResponse
			&& fullData.crrResponse.response) {
			var crr = fullData.crrResponse.response;
			if (('ridicskyPrukaz' in crr)
				&& crr.ridicskyPrukaz
				&& (crr.ridicskyPrukaz.length > 0)) {
				$desperadoBlock.find('[id^=desperado-drivingLicenseNumber-]').val(
					crr.ridicskyPrukaz[0].cisloRp
				).trigger('change');
			}
		}

		if ($desperadoBlock.next('.previous-records')) {
			$desperadoBlock.next('.previous-records').remove();
		}

		if (window.$desperadoController) {
			window.$desperadoController.lockDesperado(false);
			if (input) {
				window.$desperadoController.findDesperado(input);
			}
		}

		return filled;
	}

	/**
	 *
	 * @param data
	 * @param $desperadoBlock
	 */
	processCompanyData(data, $desperadoBlock) {
		var app = this,
			filled = [];


		if (('ico' in data) && data.ico) {
			$desperadoBlock.find('[id^=desperado-ico-]').val(data.ico).trigger('change');
			filled.push('desperado-ico');
		}

		if (('agendy' in data) && data.agendy && (data.agendy.length > 0)) {
			var agenda0 = data.agendy[0];
			$desperadoBlock.find('[id^=desperado-companyName-]').val(agenda0.jmeno).trigger('change');
			filled.push('desperado-companyName');

			if ('adresa' in agenda0) {
				app.processDesperadoAddress(agenda0.adresa, $desperadoBlock)
			}
		}

		var personNote = $desperadoBlock.find('[id^=desperado-note-]').val();
		if (('datoveSchranky' in data) && data.datoveSchranky && (data.datoveSchranky.length > 0)) {
			if (personNote.length > 0) {
				personNote += "; ";
			}
			personNote += "Číslo datové schránky: " + data.datoveSchranky[0];
		}
		if (personNote.length > 0) {
			$desperadoBlock.find('[id^=desperado-note-]').val(personNote).trigger('change');
			filled.push('desperado-note');
		}

		return filled;
	}

	/**
	 *
	 */
	processOperatorData(data) {
		var app = this,
			$button = $('#add-desperado-desperado'),
			$desperadoBlock = null,
			filled = [];

		if (window.$desperadoController) {
			window.$desperadoController.lockDesperado(true);
		}

		//Make sure desperados tab is open
		var $header = $('.panel.wd-desperados > .panel-heading');
		if ($header.hasClass('hiding-hidden')) {
			window.$wdEventCommon.togglePanelBody($header);
		}

		//If desperado is already filled, add witness
		if ($button.attr("disabled")) {
			$desperadoBlock = $('#desperados-list').find('.wd-desperado.type-a_desperado');
		} else {
			$desperadoBlock = window.$desperadoController.addDesperado($button);
		}
		$desperadoBlock.find('.panel-heading').removeClass('hiding-hidden');
		$desperadoBlock.find('.panel-body').removeClass('hiding-body-hidden').removeClass('hiding-body-hiding').css('height', 'auto');

		//Pravnicka osoba
		if (("typProvozovatele" in data) && data.typProvozovatele && (data.typProvozovatele == "EKONOMICKY_SUBJEKT")) {
			$desperadoBlock.find('.company-person-tabs [data-value=company] > a').trigger('click');

			$desperadoBlock.find('[id^=desperado-ico-]').val(data.ico).trigger('change');
			$desperadoBlock.find('[id^=desperado-companyName-]').val(data.obchodniNazevSpolecnosti).trigger('change');

			filled = filled.concat(['desperado-ico', 'desperado-companyName']);
		} else {
			$desperadoBlock.find('.company-person-tabs [data-value=person] > a').trigger('click');

			if (('rodneCislo' in data) && data.rodneCislo) {
				$desperadoBlock.find('[id^=desperado-personalId-]').val(data.rodneCislo).trigger('change');
				filled.push('desperado-personalId');
			}
			if (('jmeno' in data) && data.jmeno) {
				$desperadoBlock.find('[id^=desperado-firstName-]').val(data.jmeno).trigger('change');
				filled.push('desperado-firstName');
			}
			if (('prijmeni' in data) && data.prijmeni) {
				$desperadoBlock.find('[id^=desperado-lastName-]').val(data.prijmeni).trigger('change');
				filled.push('desperado-lastName');
			}
			if (('datumNarozeni' in data) && data.datumNarozeni) {
				var matches = data.datumNarozeni.match(/(?<y>\d+)-(?<m>\d+)-(?<d>\d+).*/)
				if (matches && ('groups' in matches) && matches.groups) {
					var date = "";
					if ((('d' in matches.groups) && matches.groups.d)
						&& (('m' in matches.groups) && matches.groups.m)
						&& (('y' in matches.groups) && matches.groups.y)) {
						date += matches.groups.d + "." + matches.groups.m + "." + matches.groups.y;
					}
					$desperadoBlock.find('[id^=desperado-birthDate-]').val(date).trigger('change');
					filled.push('desperado-birthDate');
				}
			}

			var personNote = $desperadoBlock.find('[id^=desperado-note-]').val();
			if (('ico' in data) && data.ico) {
				if (personNote.length > 0) {
					personNote += "; ";
				}
				personNote += data.ico;
			}
			if (('obchodniNazevSpolecnosti' in data) && data.obchodniNazevSpolecnosti) {
				if (personNote.length > 0) {
					personNote += "; ";
				}
				personNote += data.obchodniNazevSpolecnosti;
			}
			if (personNote.length > 0) {
				$desperadoBlock.find('[id^=desperado-note-]').val(personNote).trigger('change');
				filled.push('desperado-note');
			}
		}

		if (('adresa' in data) && data.adresa) {
			filled = filled.concat(app.processDesperadoAddress(data.adresa, $desperadoBlock));
		}

		if (window.$desperadoController) {
			window.$desperadoController.lockDesperado(false);
		}

		return filled;
	}

	/**
	 *
	 */
	processDesperadoAddress(data, $desperadoBlock) {
		var app = this,
			filled = [],
			ulice = (('ulice' in data) && data.ulice) ? data.ulice : (
				(('mestskaCast' in data) && data.mestskaCast) ? data.mestskaCast : null);
		if (ulice) {
			app.setSelectValue($desperadoBlock.find('[id^=desperado-Street-]'), ulice);
			filled.push('desperado-Street');
		}
		if (('cisloPopisne' in data) && data.cisloPopisne) {
			$desperadoBlock.find('[id^=desperado-HouseNo-]').val(data.cisloPopisne).trigger('change');
			filled.push('desperado-HouseNo');
		}
		if (('cisloOrientacni' in data) && data.cisloOrientacni) {
			$desperadoBlock.find('[id^=desperado-HouseN-]').val(data.cisloOrientacni).trigger('change');
			filled.push('desperado-HouseN');
		}
		if (('mesto' in data) && data.mesto) {
			app.setSelectValue($desperadoBlock.find('[id^=desperado-Town-]'), data.mesto);
			filled.push('desperado-HouseNo');
		}
		if (('okres' in data) && data.okres) {
			app.setSelectValue($desperadoBlock.find('[id^=desperado-County-]'), data.okres);
			filled.push('desperado-County');
		}
		if (('smerovaciCislo' in data) && data.smerovaciCislo) {
			app.setSelectValue($desperadoBlock.find('[id^=desperado-Zip-]'), data.smerovaciCislo);
			filled.push('desperado-Zip');
		}

		if (('stat' in data) && data.stat) {
			app.setSelectValue($desperadoBlock.find('[id^=desperado-Country-]'), data.stat);
			filled.push('desperado-Country');
		}

		if (('poznamka' in data)) {
			var $addressNoteBlock = $desperadoBlock.find('[id^=desperado-AddressNote-]');
			if (data.poznamka) {
				$addressNoteBlock.find('input').val(data.poznamka);
				$addressNoteBlock.find('div.alert').html(data.poznamka);
				$addressNoteBlock.removeClass('hidden');
			} else {
				$addressNoteBlock.find('input').val("");
				$addressNoteBlock.find('div.alert').html("");
				$addressNoteBlock.addClass('hidden');
			}
			filled.push('desperado-AddressNote');
		}

		//Schedule authorities load
		if (app.$options.private.loadAuthoritiesTimeout != null) {
			window.clearTimeout(app.$options.private.loadAuthoritiesTimeout);
		}
		app.$options.private.loadAuthoritiesTimeout = window.setTimeout(function () {
			window.$desperadoController.findAuthority($desperadoBlock.find('[id^=desperado-Zip-]'), null);
			app.$options.private.loadAuthoritiesTimeout = null;
		}, 100);

		return filled;
	}

	//---------------------------------------------------------------------

	/**
	 *
	 */
	processSuccessWDCRV(result) {
		var app = this,
			boxData = "",
			lang = $Lang,
			choice = app.$options.logResult,
			parser = new RegistryDataParser(result);
		boxData += parser.getHtml();
		bootbox.dialog({
			message: boxData,
			title: lang.registry.form.confirmTitle.replace(/:date/g, $('#time_date').val()),
			buttons: {
				confirm: {
					label: lang.registry.form.dataOk,
					className: 'btn-success',
					callback() {
						var filled = app.processStagecoachData(result.crvResponse.response, false);
						app.updateLog(result.logId, choice.filled, filled);
					}
				},
				confirmWithOperator: {
					label: lang.registry.form.dataOkOperator,
					className: 'btn-warning hidden-xs',
					callback() {
						var filled = app.processStagecoachData(result.crvResponse.response, true);
						app.updateLog(result.logId, choice.filled, filled);
					}
				},
				cancel: {
					label: lang.registry.form.dataError,
					className: 'btn-danger',
					callback() {
						app.updateLog(result.logId, choice.discarded, null);
					}
				}
			},
		});
		//Adjust height
		window.setTimeout(function () {
			var height = Math.max(300, (window.innerHeight - 200));
			$('.modal-dialog .bootbox-body').css('max-height', height).css('overflow-y', 'auto');
		}, 100);
	}

	/**
	 *
	 * @param result
	 * @param $desperadoBlock
	 * @param lookupByPassport
	 * @param chain			enum	0: none; 1: isep download; 2: isep upload; 3: isrt
	 * @param isepMethod	"PUT" / "POST" / "DELETE"
	 */
	processSuccessWDROB(result, $desperadoBlock, lookupByPassport, chain, isepMethod) {
		var app = this,
			boxData = "",
			lang = $Lang,
			choice = app.$options.logResult,
			parser = new RegistryDataParser(result);
		boxData += parser.getHtml();
		bootbox.confirm({
			message: boxData,
			title: lang.registry.form.confirmTitleRob,
			buttons: {
				confirm: {
					label: lang.registry.form.dataOk,
					className: 'btn-success'
				},
				cancel: {
					label: lang.registry.form.dataError,
					className: 'btn-danger'
				}
			},
			callback(confirmed) {
				if (confirmed) {
					var filled = app.processDesperadoData(result, $desperadoBlock, lookupByPassport);
					switch (chain) {
						case CHAIN_ISEP_DOWNLOAD:
							app.downloadIsep($desperadoBlock);
							break;
						case CHAIN_ISEP_UPLOAD:
							app.uploadIsep($desperadoBlock, isepMethod);
							break;
						case CHAIN_ISRT:
							app.downloadIsrt($desperadoBlock, null);
							break;
					}
					app.updateLog(result.logId, choice.filled, filled);
				} else {
					app.updateLog(result.logId, choice.discarded, null);
				}
			}
		});
		//Adjust height
		window.setTimeout(function () {
			var height = Math.max(300, (window.innerHeight - 200));
			$('.modal-dialog .bootbox-body').css('max-height', height).css('overflow-y', 'auto');
		}, 100);
	}

	/**
	 *
	 */
	processSuccessWDROS(result, $desperadoBlock) {
		var app = this,
			boxData = "",
			lang = $Lang,
			choice = app.$options.logResult,
			parser = new RegistryDataParser(result);
		boxData += parser.getHtml();
		bootbox.confirm({
			message: boxData,
			title: lang.registry.form.confirmTitleRob,
			buttons: {
				confirm: {
					label: lang.registry.form.dataOk,
					className: 'btn-success'
				},
				cancel: {
					label: lang.registry.form.dataError,
					className: 'btn-danger'
				}
			},
			callback(confirmed) {
				if (confirmed) {
					var filled = app.processCompanyData(result.rosResponse.response, $desperadoBlock);
					app.updateLog(result.logId, choice.filled, filled);
				} else {
					app.updateLog(result.logId, choice.discarded, null);
				}
			}
		});
		//Adjust height
		window.setTimeout(function () {
			var height = Math.max(300, (window.innerHeight - 200));
			$('.modal-dialog .bootbox-body').css('max-height', height).css('overflow-y', 'auto');
		}, 100);
	}

	//---------------------------------------------------------------------

	processError(data, translateKeys, $block) {
		if (('responseJSON' in data)
			&& (typeof data.responseJSON === 'object')) {
			if ('errors' in data.responseJSON) {
				inputErrors = (translateKeys !== undefined)
					? translateKeys(data.responseJSON.errors, $block)
					: data.responseJSON.errors;
				//If date is wrong, make sure description panel is open
				if (('time_date' in inputErrors) || ('time_time' in inputErrors)) {
					var $header = $('.panel.wd-description > .panel-heading');
					if ($header.hasClass('hiding-hidden')) {
						window.$wdEventCommon.togglePanelBody($header);
					}
				}

				$customs.checkErrors();
				bootbox.alert("Dotaz obsahuje chyby, zkontrolujte formulář.");
			} else if ('error' in data.responseJSON) {
				bootbox.alert("Požadavek se nezdařil (" + data.responseJSON.error + "). Zkuste akci opakovat později.");
			} else if ('message' in data.responseJSON) {
				bootbox.alert("Požadavek se nezdařil (" + data.responseJSON.message + "). Zkuste akci opakovat později.");
			}
		} else {
			bootbox.alert("Požadavek se nezdařil (" + data.statusText + "). Zkuste akci opakovat později.");
		}
	}

	//---------------------------------------------------------------------

	updateLog(logId, result, filledColumns) {
		var app = this;

		$.ajax({
			type: "post",
			url: route('registry.log.update'),
			data: {
				id: logId,
				result: result,
				cols: filledColumns,
			},
			success(r) {
			},
			error(r) {
				console.error(r);
			},
		});
	}

	//=====================================================================

	loadCRVDataFromWD() {
		return {
			licence_plate: $('#licensePlate').val(),
			vin: $('#vin').val(),
			reason: window.$Common.registry.reasonCRV,
			reason_detail: $Lang.registry.inFormReasonDetail,
			date: $('#time_date').val(),
			time: $('#time_time').val(),
			wd_id: $('#input_wd_id').val(),
			session_id: $('#input_session_id').val(),
			lat: $('#lat').val(),
			lon: $('#lon').val(),
			request_address: $('#trailId').text().trim()
		};
	}

	loadWDCRV() {
		var app = this,
			data = this.loadCRVDataFromWD();

		app.registryButtonDisable();
		$customs.cleanErrors();

		$.ajax({
			type: "post",
			url: route('registry.crv.store'),
			data: JSON.stringify(data),
			success(r) {
				app.registryButtonEnable();
				app.processSuccessWDCRV(r);
			},
			error(r) {
				app.registryButtonEnable();
				app.processError(r, app.translateCRVKeys, null);
			},
			dataType: "json",
			contentType: "application/json",
			timeout: 60000,
		});
	}

	translateCRVKeys(array, $block) {
		var wdKeyTranslationTable = {
				'licence_plate': 'stagecoach.licence_plate',
				'vin': 'stagecoach.vin',
				'date': 'time_date',
				'time': 'time_time',
			},
			modified = {};
		$.each(array, function (i, e) {
			if (i in wdKeyTranslationTable) {
				modified[wdKeyTranslationTable[i]] = e;
			} else {
				modified[i] = e;
			}
		});
		return modified;
	}

	//---------------------------------------------------------------------

	loadROBDataFromWD($desperadoBlock, searchBy) {
		var cardTypes = this.$options.idCardType,
			data = {
				first_name: $desperadoBlock.find('[id^=desperado-firstName-]').val(),
				last_name: $desperadoBlock.find('[id^=desperado-lastName-]').val(),
				birth_date: $desperadoBlock.find('[id^=desperado-birthDate-]').val(),
				driving_licence: $desperadoBlock.find('[id^=desperado-drivingLicenseNumber-]').val(),
				search_by: searchBy,
				reason: window.$Common.registry.reasonROB,
				reason_detail: $Lang.registry.inFormReasonDetail,
				read_eop: false,
				read_crr: this.$options.traffic,
				wd_id: $('#input_wd_id').val(),
				session_id: $('#input_session_id').val(),
				lat: $('#lat').val(),
				lon: $('#lon').val(),
				request_address: $('#trailId').text().trim()
			},
			opt = this.$options.searchBy;

		switch ($desperadoBlock.find('[id^=desperado-identification-]').val()) {
			case cardTypes.idCard:
				data.id_card_number = $desperadoBlock.find('[id^=desperado-cardNumber-]').val();
				if (!searchBy) {
					if (data.id_card_number) {
						data.search_by = opt.op;
					} else {
						data.search_by = opt.name;
					}
				}
				break;
			case cardTypes.passport:
				data.passport = $desperadoBlock.find('[id^=desperado-cardNumber-]').val();
				if (!searchBy) {
					data.search_by = opt.passport;
				}
				break;
			default:
				if (data.driving_licence) {
					data.search_by = opt.rp;
				} else if (!data.birth_date) {
					bootbox.alert('Neplatný typ dokladu');
					data = null;
				} else {
					data.search_by = opt.name;
				}
				break;
		}
		return data;
	}

	/**
	 * @param $button 		jQuery element
	 * @param chain			enum	0: none; 1: isep download; 2: isep upload; 3: isrt
	 * @param isepMethod
	 */
	loadWDROB($button, chain, isepMethod) {
		if (!$button.hasClass('disabled')) {
			var app = this,
				$desperadoBlock = $button.closest('.panel-body'),
				data = this.loadROBDataFromWD($desperadoBlock, (chain === 0) ? $button.data('searchBy') : null);

			if (data) {
				app.registryButtonDisable();
				$customs.cleanErrors();

				$.ajax({
					type: "post",
					url: route('registry.rob.store'),
					data: JSON.stringify(data),
					success(r) {
						app.registryButtonEnable();
						app.processSuccessWDROB(r, $desperadoBlock, ("passport" in data), chain, isepMethod);
					},
					error(r) {
						app.registryButtonEnable();
						app.processError(r, app.translateROBKeys, $desperadoBlock);
					},
					dataType: "json",
					contentType: "application/json",
					timeout: 60000,
				});
			}
		}
	}

	translateROBKeys(array, $block) {
		var index = $block.closest('.panel').data('key'),
			wdKeyTranslationTable = {
				'first_name': 'desperados.' + index + '.first_name',
				'last_name': 'desperados.' + index + '.last_name',
				'birth_date': 'desperados.' + index + '.birth_date',
				'id_card_number': 'desperados.' + index + '.card_number',
				'passport': 'desperados.' + index + '.card_number',
				'driving_licence': 'desperados.' + index + '.driving_lic_no',
			},
			modified = {};
		$.each(array, function (i, e) {
			if (i in wdKeyTranslationTable) {
				modified[wdKeyTranslationTable[i]] = e;
			} else {
				modified[i] = e;
			}
		});
		return modified;
	}


	//=====================================================================

	processSuccessIsep(readResult, $desperadoBlock) {
		var app = this,
			boxData = "",
			lang = $Lang,
			choice = app.$options.logResult,
			result = app.mergeIsepResults(readResult),
			parser = new RegistryDataParser(result);
		boxData += parser.getHtml();

		var link = null;
		try {
			link = result.isepSelectResponse.response.outputFileLink;
		} catch (e) {
			console.error(e);
		}

		bootbox.confirm({
			message: boxData,
			title: lang.registry.form.confirmTitleRob,
			buttons: {
				confirm: {
					label: lang.common.show,
					className: 'btn-success'
				},
				cancel: {
					label: lang.common.close,
					className: 'btn-danger'
				}
			},
			callback(confirmed) {
				if (confirmed && window.$customs) {
					window.$customs.displayDocumentPopup(link, app.processIsepRedirectStatic);
				} else {
					app.processIsepRedirect();
				}
			}
		});

		app.updateLog(result.logId, choice.filled, []);
		//Adjust height
		window.setTimeout(function () {
			var height = Math.max(300, (window.innerHeight - 200));
			$('.modal-dialog .bootbox-body').css('max-height', height).css('overflow-y', 'auto');
		}, 100);
	}

	downloadIsep($desperadoBlock) {
		var app = this,
			data = app.$options.private.isepInputData;

		//Check if there are any changes to be saved
		if (window.$wdEventCommon && window.$wdEventCommon.isDirty()) {
			bootbox.alert($Lang.registry.form.wrongDoingDirty);
			return;
		}

		app.registryButtonDisable();
		$.ajax({
			type: "get",
			url: route('registry.isep'),
			data: data,
			success(r) {
				app.registryButtonEnable();
				app.processSuccessIsep(r, $desperadoBlock);
			},
			error(r) {
				app.registryButtonEnable();
				app.processError(r, app.translateISEPKeys, $desperadoBlock);
			},
			dataType: "json",
			contentType: "application/json",
			timeout: 60000,
		});
	}

	loadISEPDataFromWD($desperadoBlock) {
		return {
			aifo: $desperadoBlock.find('[id^=desperado-aifo-]').val(),
			first_name: $desperadoBlock.find('[id^=desperado-firstName-]').val(),
			last_name: $desperadoBlock.find('[id^=desperado-lastName-]').val(),
			birth_date: $desperadoBlock.find('[id^=desperado-birthDate-]').val(),
			nationality_id: parseInt($desperadoBlock.find('[id^=desperado-nationality-]').val()),
			country_of_origin_id: parseInt($desperadoBlock.find('[id^=desperado-countryOfOrigin-]').val()),
			place_of_origin: $desperadoBlock.find('[id^=desperado-placeOfOrigin-]').val(),
			town_of_origin_id: parseInt($desperadoBlock.find('[id^=desperado-townOfOrigin-]').val()),
			wd_id: $('#input_wd_id').val(),
			event_id: $('#input_event_id').val(),
			lat: $('#lat').val(),
			lon: $('#lon').val(),
			request_address: $('#trailId').text().trim(),
			reason: window.$Common.registry.reasonROB,
			reason_detail: $Lang.registry.inFormReasonDetail,
		};
	}

	loadWDISEP($button) {
		var app = this,
			$desperadoBlock = $button.closest('.panel-body'),
			data = this.loadISEPDataFromWD($desperadoBlock),
			originalCountry = parseInt(app.$options.countryOfOriginId);

		if (data) {

			app.$options.private.isepInputData = data;
			if ((data.nationality_id === originalCountry) && !data.aifo) {
				app.loadWDROB($button, CHAIN_ISEP_DOWNLOAD, null);
			} else {
				app.downloadIsep($desperadoBlock);
			}
		}
	}

	translateISEPKeys(array, $block) {
		var index = $block.closest('.panel').data('key'),
			wdKeyTranslationTable = {
				'first_name': 'desperados.' + index + '.first_name',
				'last_name': 'desperados.' + index + '.last_name',
				'birth_date': 'desperados.' + index + '.birth_date',
				'nationality': 'desperados.' + index + '.nationality_id',
				'country_of_origin': 'desperados.' + index + '.country_of_origin',
				'place_of_origin': 'desperados.' + index + '.place_of_origin',
				'id_card_number': 'desperados.' + index + '.card_number',
				'town_of_origin': 'desperados.' + index + '.town_of_origin',
			},
			modified = {};
		$.each(array, function (i, e) {
			if (i in wdKeyTranslationTable) {
				modified[wdKeyTranslationTable[i]] = e;
			} else {
				modified[i] = e;
			}
		});
		return modified;
	}

	//=====================================================================

	uploadWDISEP($button, method) {
		var app = this,
			$desperadoBlock = $button.closest('.panel-body'),
			data = this.loadISEPDataFromWD($desperadoBlock),
			originalCountry = parseInt(app.$options.countryOfOriginId);

		if (data) {
			app.$options.private.isepInputData = data;
			if ((data.nationality_id === originalCountry) && !data.aifo) {
				console.log("No AIFO, requesting ROB", data.aifo, (data.nationality_id === originalCountry), ((data.nationality_id === originalCountry) && !data.aifo) ? "true" : "false");
				app.loadWDROB($button, CHAIN_ISEP_UPLOAD, method);
			} else {
				app.uploadIsep($desperadoBlock, method);
			}
		}
	}

	isepGetReason($desperadoBlock, method) {
		var app = this,
			options = [],
			isepOptions = (method === "POST") ? $Lang.wrongDoings.isepEditOptions : $Lang.wrongDoings.isepDeleteOptions,
			title = (method === "POST") ? $Lang.wrongDoings.isepEditTitle : $Lang.wrongDoings.isepDeleteTitle,
			$reasonField = (method === "POST") ? $('#edit_reason') : $('#delete_reason');

		$.each(isepOptions, function (i, el) {
			options.push({text: el, value: i});
		});
		var resetDirty = window.$wdEventCommon && !window.$wdEventCommon.isDirty();
		bootbox.prompt({
			title: title,
			message: title,
			inputType: 'select',
			inputOptions: options,
			value: $reasonField.val(),
			callback(reason) {
				if (reason) {
					if (reason !== $reasonField.val()) {
						$reasonField.val(reason).trigger('change');
						if (resetDirty) {
							window.$wdEventCommon.resetDirty();
						}
					}

					app.uploadIsepFinish($desperadoBlock, method, reason);
				}
			}
		});
	}

	uploadIsep($desperadoBlock, method) {
		var app = this;

		if ((method === "POST") || (method === "DELETE")) {
			app.isepGetReason($desperadoBlock, method);
		} else {
			app.uploadIsepFinish($desperadoBlock, method, "Zápis přestupku do ISEP");
		}
	}

	uploadIsepFinish($desperadoBlock, method, reason) {
		var app = this;

		//Check if there are any changes to be saved
		if (window.$wdEventCommon && window.$wdEventCommon.isDirty()) {
			bootbox.alert($Lang.registry.form.wrongDoingDirty);
			return;
		}

		bootbox.confirm({
			message: $Lang.registry.form.confirmIsepUpload,
			title: $Lang.registry.form.confirmIsepUploadTitle,
			buttons: {
				confirm: {
					label: $Lang.common.yes,
					className: 'btn-success'
				},
				cancel: {
					label: $Lang.common.no,
					className: 'btn-danger'
				}
			},
			callback(confirmed) {
				if (confirmed) {
					app.registryButtonDisable();
					var now = new Date();

					$.ajax({
						type: method,
						url: route('registry.isep'),
						data: JSON.stringify({
							id: $desperadoBlock.parent().data('key'),
							reason: reason,
							reason_detail: "Zápis přestupku do ISEP",
							wd_id: $('#input_wd_id').val(),
							date: now.getDate() + "." + now.getMonth() + "." + now.getFullYear(),
							time: now.getHours() + ":" + String(now.getMinutes()).padStart(2, '0'),
						}),
						success(result) {
							app.registryButtonEnable();
							if ('status' in result) {
								app.processIsepWriteResult(result, result.status, $desperadoBlock);
							}
						},
						error(r) {
							app.registryButtonEnable();
							app.processError(r, app.translateISEPKeys, $desperadoBlock);
						},
						dataType: "json",
						contentType: "application/json",
						timeout: 60000,
					});
				}
			}
		});
	}

	processIsepWriteResult(result, status, $desperadoBlock) {
		var app = this,
			performDownload = false;
		switch (status) {
			case "error":
				bootbox.alert(result.statusDetail);
				break;

			case "success_delete":
			case "success_insert":
				performDownload = true;
				break;

			default:
				console.log(result);
				break;
		}

		if (performDownload) {
			app.$options.private.isepWriteResult = result;
			app.downloadIsep($desperadoBlock);
		}
	}

	mergeIsepResults(readResult) {
		var writeResult = this.$options.private.isepWriteResult;
		if (writeResult) {
			if (('isepInsertResponse' in writeResult) && (writeResult.isepInsertResponse.statusKod !== "NEDOTAZAN")) {
				readResult.isepInsertResponse = writeResult.isepInsertResponse;
			}
			if (('isepDeleteResponse' in writeResult) && (writeResult.isepDeleteResponse.statusKod !== "NEDOTAZAN")) {
				readResult.isepDeleteResponse = writeResult.isepDeleteResponse;
			}
		}
		return readResult;
	}

	processIsepRedirectStatic() {
		if (window.$registry) {
			window.$registry.processIsepRedirect();
		} else if (window.$registryController) {
			window.$registryController.processIsepRedirect();
		}
	}

	processIsepRedirect() {
		var writeResult = this.$options.private.isepWriteResult;
		if (writeResult && ('status' in writeResult)) {
			switch (writeResult.status) {
				case "success_insert":
					if (('redirect' in writeResult) && writeResult.redirect) {
						window.location.href = writeResult.redirect;
					}
					break;

				case "success_delete":
					window.location.reload();
					break;

				default:
					break;
			}
			this.$options.private.isepWriteResult = null;
		} else {
			window.location.reload();
		}
	}

	//=====================================================================

	checkDesperadoNationality($select) {
		var app = this,
			$desperadoPanel = $select.closest('.panel.wd-desperado'),
			$panel = ($desperadoPanel.length > 0) ? $desperadoPanel : $select.closest('.panel.panel-default'),
			originalNationality = app.$options.countryOfOriginId,
			selectedNationality = $select.val(),
			$cooSelect = $panel.find("select[id^='desperado-countryOfOrigin-']");
		if (parseInt(originalNationality) !== parseInt(selectedNationality)) {
			$panel.find('.country-of-origin-cell').removeClass('hidden');
			app.checkDesperadoCOO($cooSelect);
		} else {
			$panel.find('.country-of-origin-cell').addClass('hidden');
			$panel.find('.place-of-origin-cell').addClass('hidden');
			$panel.find('.town-of-origin-cell').addClass('hidden');
			app.checkIsepLoadButtonEnabled($panel);
		}
	}

	checkDesperadoCOO($select) {
		var app = this,
			$desperadoPanel = $select.closest('.panel.wd-desperado'),
			$panel = ($desperadoPanel.length > 0) ? $desperadoPanel : $select.closest('.panel.panel-default'),
			originalNationality = app.$options.countryOfOriginId,
			selectedNationality = $select.val();
		if (parseInt(originalNationality) !== parseInt(selectedNationality)) {
			$panel.find('.place-of-origin-cell').removeClass('hidden');
			$panel.find('.town-of-origin-cell').addClass('hidden');
		} else {
			$panel.find('.place-of-origin-cell').addClass('hidden');
			$panel.find('.town-of-origin-cell').removeClass('hidden');
		}
		app.checkIsepLoadButtonEnabled($panel);
	}

	checkIsepLoadButtonEnabled($panel) {
		var app = this,
			$isepButton = $panel.find("button[id^='desperado-loadIsep-']");

		$isepButton.attr('disabled', 'disabled');
		if (app.$options.id != null) {
			var originalNationality = app.$options.countryOfOriginId,
				$nationalitySelect = $panel.find("select[id^='desperado-nationality-']"),
				$cooSelect = $panel.find("select[id^='desperado-countryOfOrigin-']"),
				$placeOOInput = $panel.find('.place-of-origin-cell > input'),
				$townOOSelect = $panel.find('.town-of-origin-cell > select');


			if (parseInt(originalNationality) !== parseInt($nationalitySelect.val())) {
				if (parseInt(originalNationality) !== parseInt($cooSelect.val())) {
					if ($placeOOInput.val()) {
						$isepButton.removeAttr('disabled');
					}
				} else {
					if ($townOOSelect.val()) {
						$isepButton.removeAttr('disabled');
					}
				}
			} else {
				$isepButton.removeAttr('disabled');
			}
		}
	}

	//=====================================================================
	
	loadWDROS($button) {
		if (!$button.hasClass('disabled')) {
			var app = this,
				$desperadoBlock = $button.closest('.panel-body'),
				ico = $button.parent().find('input').val(),
				data = {
					ico: ico,
					reason: window.$Common.registry.reasonROB,
					reason_detail: $Lang.registry.inFormReasonDetail,
					wd_id: $('#input_wd_id').val(),
					session_id: $('#input_session_id').val(),
				};

			if (ico) {
				app.registryButtonDisable();
				$customs.cleanErrors();

				$.ajax({
					type: "post",
					url: route('registry.ros.store'),
					data: JSON.stringify(data),
					success(r) {
						app.registryButtonEnable();
						app.processSuccessWDROS(r, $desperadoBlock);
					},
					error(r) {
						app.registryButtonEnable();
						app.processError(r, app.translateROBKeys, $desperadoBlock);
					},
					dataType: "json",
					contentType: "application/json",
					timeout: 60000,
				});
			}
		}
	}

	//=====================================================================

	checkIsrtNationality($select) {
		let app = this,
			$desperadoPanel = $select.closest('.panel.wd-desperado'),
			$panel = ($desperadoPanel.length > 0) ? $desperadoPanel : $select.closest('.panel.panel-default'),
			originalNationality = app.$options.countryOfOriginId,
			selectedNationality = $select.val(),
			isForeigner = (parseInt(originalNationality) !== parseInt(selectedNationality));
		
		//Display or hide buttons
		if (isForeigner) {
			//Hide ISRT button in wrong doing panel
			$panel.find('.check-isrt').addClass('hidden');

			//Display has_aifo radio
			$('#has-aifo-radio').removeClass('hidden');
		} else {
			//Display ISRT button in wrong doing panel
			$panel.find('.check-isrt').removeClass('hidden');

			//Hide has_aifo radio
			$('#has-aifo-radio').addClass('hidden');
		}
		
		//Free form only
		if ($desperadoPanel.length === 0) {
			let hasAifo = $('#has-aifo-yes').get(0).checked;
			app.checkAifoForeignerForm(!isForeigner || hasAifo);
		}
	}
	
	checkAifoForeignerForm(hasAifo) {
		if (hasAifo) {
			//Display AIFO form, hide foreigner form
			$('#registry-form-aifo').removeClass('hidden');
			$('#registry-form-foreigner').addClass('hidden');
		} else {
			//Hide AIFO form, display foreigner form and has_aifo radio
			$('#registry-form-aifo').addClass('hidden');
			$('#registry-form-foreigner').removeClass('hidden');
		}
	}
	
	//=====================================================================

	processSuccessIsrt(result) {
		var app = this,
			boxData = "",
			lang = $Lang,
			choice = app.$options.logResult,
			parser = new RegistryDataParser(result),
			buttons = {};
		boxData += parser.getHtml();

		var link = null;
		try {
			link = result.isrtResponse.response.outputFileLink;
			buttons['confirm'] = {
					label: lang.common.show,
					className: 'btn-success'
				};
		} catch (e) {
			console.error(e);
		}
		buttons['cancel'] = {
				label: lang.common.close,
				className: 'btn-danger'
			};

		bootbox.confirm({
			message: boxData,
			title: lang.registry.form.confirmTitleRob,
			buttons: buttons,
			callback(confirmed) {
				//Display document
				if (confirmed && window.$customs && link) {
					window.$customs.displayDocumentPopup(link, app.processIsepRedirectStatic);
				} else {
					//Just refresh
					window.location.reload();
				}
			}
		});

		app.updateLog(result.logId, choice.filled, []);
		//Adjust height
		window.setTimeout(function () {
			var height = Math.max(300, (window.innerHeight - 200));
			$('.modal-dialog .bootbox-body').css('max-height', height).css('overflow-y', 'auto');
		}, 100);
	}

	downloadIsrt($desperadoBlock, data) {
		var app = this;
		
		//Check if there are any changes to be saved
		if (window.$wdEventCommon && window.$wdEventCommon.isDirty()) {
			bootbox.alert($Lang.registry.form.wrongDoingDirty);
			return;
		}

		if (data == null) {
			data = app.loadISRTDataFromWD($desperadoBlock)
		}
		app.registryButtonDisable();
		$.ajax({
			type: "post",
			url: route('registry.isrt.store'),
			data: JSON.stringify(data),
			success(r) {
				app.registryButtonEnable();
				app.processSuccessIsrt(r);
			},
			error(r) {
				app.registryButtonEnable();
				app.processError(r, app.translateISEPKeys, $desperadoBlock);
			},
			dataType: "json",
			contentType: "application/json",
			timeout: 60000,
		});
	}
	
	downloadIsrtResult(requestId) {
		let app = this;
		app.registryButtonDisable();
		
		$.ajax({
			type: "post",
			url: route('registry.isrt.result'),
			data: JSON.stringify({
				id: requestId,
				wd_id: $('#input_wd_id').val(),
				event_id: $('#input_event_id').val(),
				session_id: $('#input_session_id').val(),
			}),
			success(r) {
				app.registryButtonEnable();
				app.processSuccessIsrt(r);
			},
			error(r) {
				app.registryButtonEnable();
				app.processError(r, app.translateISEPKeys, null);
			},
			dataType: "json",
			contentType: "application/json",
			timeout: 60000,
		});
	}
	
	loadISRTDataFromWD($desperadoBlock) {
		return {
			aifo: $desperadoBlock.find('[id^=desperado-aifo-]').val(),
			full: false,
			wd_id: $('#input_wd_id').val(),
			event_id: $('#input_event_id').val(),
			session_id: $('#input_session_id').val(),
			lat: $('#lat').val(),
			lon: $('#lon').val(),
			request_address: $('#trailId').text().trim(),
			reason: $Lang.registry.reasons.ISRT,
			reason_detail: $Lang.registry.inFormReasonDetail,
		};
	}
	
	loadWDISRT($button) {
		var app = this,
			$desperadoBlock = $button.closest('.panel-body'),
			data = this.loadISRTDataFromWD($desperadoBlock);
		if (!data.aifo) {
			app.loadWDROB($button, CHAIN_ISRT, null);
		} else {
			app.downloadIsrt($desperadoBlock, data);
		}
	}
	
	//=====================================================================

	toggleRawData($heading) {
		var $rawTable = $('div.raw-data');
		if ($rawTable.hasClass('hidden')) {
			$rawTable.removeClass('hidden');
			$heading.removeClass('raw-hidden');
		} else {
			$rawTable.addClass('hidden');
			$heading.addClass('raw-hidden');
		}
	}

	setPositionType(typeId) {
		var $row = $("#" + typeId + "Row");

		$('.positionTypeRow').find('input[type="text"], select').attr('disabled', 'disabled');
		$row.find('input[type="text"], select').removeAttr('disabled');

		if (typeId === "typeLatLon") {
			window.$positionController.checkLocation(true);
		}
	}

	setSearchBy(by) {
		$('#searchBy').val(by);

		var $eop = $('#readEop'),
			$crr = $('#readCrr'),
			$aiseo = $('#readAiseo'),
			$aisc = $('#readAisc'),
			opt = this.$options.searchBy;

		$eop.removeAttr('disabled').attr('checked', 'checked').trigger('changed');
		$crr.removeAttr('disabled').attr('checked', 'checked').trigger('changed');
		$aiseo.removeAttr('disabled').attr('checked', 'checked').trigger('changed');
		$aisc.removeAttr('disabled');

		switch (by) {
			case opt.op:
			case opt.passport:
				$aisc.attr('disabled', true);
				break;
			case opt.rp:
				$crr.get(0).checked = true;
				$crr.attr('disabled', true);
				break;
		}
	}

	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document);

		$document.on('click', 'form#registryForm button.submit', function () {
			if (!$(this).attr('disabled')) {
				app.submitForm($(this.form));
			}
			return false;
		});

		$document.on('click', '.js-lookup-registry-crv', function () {
			if (!$(this).hasClass('disabled')) {
				app.loadWDCRV();
			}
			return false;
		});

		$document.on('click', '.js-lookup-registry-rob', function () {
			app.loadWDROB($(this), CHAIN_NONE, null);
			return false;
		});

		$document.on('click', '.js-lookup-registry-ros', function () {
			app.loadWDROS($(this));
			return false;
		});

		$document.on('click', ".js-lookup-registry-isep", function (e) {
			e.preventDefault();
			app.loadWDISEP($(this));
		});
		$document.on('click', ".js-lookup-registry-isrt", function (e) {
			e.preventDefault();
			app.loadWDISRT($(this));
		});

		$document.on('click', ".js-upload-registry-isep", function (e) {
			e.preventDefault();
			app.uploadWDISEP($(this), "PUT");
		});
		$document.on('click', ".js-edit-registry-isep", function (e) {
			e.preventDefault();
			app.uploadWDISEP($(this), "POST");
		});
		$document.on('click', ".js-delete-registry-isep", function (e) {
			e.preventDefault();
			app.uploadWDISEP($(this), "DELETE");
		});

		$document.on('click', 'h3.show-raw', function () {
			app.toggleRawData($(this));
		});

		$document.on('change', 'input.placeTypeRadio', function () {
			app.setPositionType($(this).attr('id'));
		});

		$document.on('click', 'li.registry-search-by-tab', function () {
			app.setSearchBy($(this).data('value'));
		});
		$document.on('change', "select#isrt-nationality", function (e) {
			app.checkIsrtNationality($(this));
		});
		$document.on('change', "#has-aifo-radio input", function (e) {
			let hasAifo = $('#has-aifo-yes').get(0).checked;
			app.checkAifoForeignerForm(hasAifo);
		});
		
		$document.on('click', '.js-download-isrt-result', function (e) {
			e.preventDefault();
			if (!$(this).attr('disabled')) {
				app.downloadIsrtResult($(this).data('requestId'));
			}
			return false;
		});
		$document.on('click', ".js-download-isrt-pdf", function (e) {
			e.preventDefault();
			console.log($(this).data('pdf'));
		});


		$document.on('change', "select[id^='desperado-nationality-']", function (e) {
			app.checkDesperadoNationality($(this));
		});
		$document.on('change', "select[id^='desperado-countryOfOrigin-']", function (e) {
			app.checkDesperadoCOO($(this));
		});
	}
}

if (!window.$registryController) {
	window.$registryController = new Registry();
}
